import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, getToken } from '../../api';
import SwipeTest from '../../components/SwipeTest';
import { femaleFacePhotos, maleFacePhotos, mixedFacePhotos } from '../../data/swipePhotos';

function scoreSwipe(photos, results) {
  const liked = photos.filter((_, i) => results[i] === 'yes');
  const counts = {
    vata:  liked.filter(p => p.type.toUpperCase().includes('V') || p.type === 'vata').length,
    pitta: liked.filter(p => p.type.toUpperCase().includes('P') || p.type === 'pitta').length,
    kapha: liked.filter(p => p.type.toUpperCase().includes('K') || p.type === 'kapha').length,
  };
  const total = Math.max(counts.vata + counts.pitta + counts.kapha, 1);
  return {
    vata:  Math.round((counts.vata  / total) * 100),
    pitta: Math.round((counts.pitta / total) * 100),
    kapha: Math.round((counts.kapha / total) * 100),
    dominant: Object.keys(counts).reduce((a, b) => counts[a] > counts[b] ? a : b),
  };
}

export default function SwipeFaces() {
  const navigate = useNavigate();
  const [photos, setPhotos] = useState(null);

  useEffect(() => {
    if (!getToken()) { navigate('/login'); return; }
    if (localStorage.getItem('swipe_test_done') === 'true') {
      navigate('/onboarding/done', { replace: true });
      return;
    }
    api.get('/profile')
      .then(p => {
        const o = (p.orientation || '').toLowerCase();
        const g = (p.gender || '').toLowerCase();
        if (o === 'men') setPhotos(maleFacePhotos);
        else if (o === 'everyone') setPhotos(mixedFacePhotos);
        else if (o === 'straight') setPhotos(['woman', 'women', 'female'].includes(g) ? maleFacePhotos : femaleFacePhotos);
        else setPhotos(femaleFacePhotos);
      })
      .catch(() => setPhotos(femaleFacePhotos));
  }, [navigate]);

  const handleComplete = (photos, results) => {
    localStorage.setItem('face_attraction', JSON.stringify(scoreSwipe(photos, results)));
    navigate('/onboarding/body-intro');
  };

  if (!photos) return <div style={{ height: '100vh', background: '#000' }} />;

  return (
    <SwipeTest
      photos={photos}
      label="FACE TYPE"
      prompt="Swipe right if this face type attracts you"
      onComplete={handleComplete}
    />
  );
}
